import styled from 'styled-components';
import { Typ20 } from 'dc/Typ';
import { Ico24 } from 'dc/Ico';
import Btn020 from 'dc/Btn020';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse; // So that a single element aligns to the right
`;

export const PageWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
`;

export const PageText = styled(Typ20)``;

type IconProps = {
  disabled?: boolean;
};

export const Icon = styled(Ico24)<IconProps>`
  cursor: ${props => (props.disabled ? 'initial' : 'pointer')};
`;

export const Button = styled(Btn020)`
  padding: 16px;
  height: initial;
`;
